import * as yup from 'yup';

export const UpdateTeacherRequiredDocumentFormValidation = yup.object().shape({
    description: yup.string().required('Tipo de documento é obrigatório'),
});